import { computed } from "vue";
import { DS_TITLE_FIELD_CLASSES } from "@/src/design_system/form_elements/title_field/constants/classes";
import type { DSTitleFieldDisplayProps } from "@/src/design_system/form_elements/title_field/types/internal";
import { DS_STATE_CLASSES } from "@/src/design_system/shared/constants/stateClasses";

export const useDSTitleFieldDisplay = (props: Readonly<DSTitleFieldDisplayProps>) => {
  const displayValue = computed(() => props.modelValue || props.placeholder || "");
  const displayControlLabel = computed(() => displayValue.value || props.ariaLabel);
  const displayControlClasses = computed(() => ({
    [DS_TITLE_FIELD_CLASSES.DisplayControl]: true,
    [DS_STATE_CLASSES.Disabled]: props.disabled,
  }));
  const displayContentClasses = computed(() => ({
    [DS_TITLE_FIELD_CLASSES.DisplayContent]: true,
    [DS_TITLE_FIELD_CLASSES.Placeholder]: !props.modelValue && Boolean(props.placeholder),
    [DS_TITLE_FIELD_CLASSES.EmptyContent]: !displayValue.value,
  }));

  return { displayValue, displayControlLabel, displayControlClasses, displayContentClasses };
};
